import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimsDashboardComponent } from './claims-dashboard.component';
import { KCardModule } from 'ng-k-card';
import { KButtonModule } from 'ng-k-button';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';


@NgModule({
  declarations: [
    ClaimsDashboardComponent
  ],
  imports: [
    CommonModule,
    KCardModule,
    KButtonModule,
    FormsModule,
    ReactiveFormsModule,
    InfiniteScrollModule
  ]
})
export class ClaimsDashboardModule { }
